import { Modal } from "react-bootstrap";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import UserIcon from "../../assets/img/user-icon.svg";
import IncomeSourceCard from "./IncomeSourceCard";
import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import { useState } from "react";

const UpdatedIncomeSourceModal = ({
  show,
  onHide,
  updateSourceObj,
  handleIncomeChange,
}) => {
  const { _t } = useTranslator();

  const [selectedSource, setSelectedSource] = useState(
    updateSourceObj?.current_selected
  );

  const changeSelectedSource = (newSource) => {
    setSelectedSource(newSource);
  };

  const initiateSourceChange = () => {
    handleIncomeChange(
      selectedSource,
      updateSourceObj?.type == "guarantor",
      updateSourceObj?._id
    );
  };
  return (
    <Modal
      show={show}
      className="metermodal modal-xl modalWidth_set updateSourceModal"
      centered
      onHide={onHide}
    >
      <h4 className="custom-modal-heading">{_t("updateIncomeSource")}</h4>
      <ClearOutlinedIcon
        className="close-button-modal"
        onClick={onHide}
        style={{ cursor: "pointer" }}
      />
      {haveValue(updateSourceObj?.all_sources) && (
        <>
          <div className="earner-info update-source-info">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <h4 className="earner-name">
              {updateSourceObj?.all_sources?.name}
            </h4>
          </div>
          <h4 className="custom-modal-heading sourceHeading">
            {_t("sources")}
          </h4>
        </>
      )}
      <div className="row income-source-card-main">
        {haveValue(updateSourceObj?.all_sources) ? (
          Object.keys(updateSourceObj.all_sources).map((data) => {
            if (data !== "name" && data !== "_id") {
              const value = updateSourceObj.all_sources[data];

              if (
                (data === "itr" || data === "bank") &&
                (value === 0 || isNaN(value))
              ) {
                return null;
              }

              return (
                <div className="col-md-6" key={data}>
                  <IncomeSourceCard
                    amount={value}
                    type={data}
                    selectedSource={selectedSource}
                    changeSelectedSource={changeSelectedSource}
                  />
                </div>
              );
            }
          })
        ) : (
          <div className="text-center my-2">
            {_t(
              "incomeSourceNotFound",
              "Text used if user doesn't have any income source"
            )}
          </div>
        )}
      </div>
      {haveValue(updateSourceObj?.all_sources) && (
        <button className="save-changes-button" onClick={initiateSourceChange}>
          {_t("saveChanges")}
        </button>
      )}
    </Modal>
  );
};

export default UpdatedIncomeSourceModal;
